module.exports = __webpack_public_path__ + "static/media/halloween.137612a4.jpg";